import {
  Swiper as SwiperComponent,
  SwiperSlide as SwiperSlideComponent,
} from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css/free-mode";
import "swiper/css";
import { useMemo } from "react";

import type { ISwiperProps } from "@components/atoms/swiper/types";
import "./styles.module.scss";

export function Swiper({ children, minWidth = "15.125rem" }: ISwiperProps) {
  const items = useMemo(() => {
    if (Array.isArray(children)) {
      return children;
    }
    return [children];
  }, [children]);

  return (
    <SwiperComponent
      style={{ width: "100%" }}
      freeMode
      spaceBetween={20}
      slidesPerView={"auto"}
      modules={[FreeMode]}
    >
      {items?.map((item, index) => {
        return (
          <SwiperSlideComponent
            key={
              /* eslint-disable-next-line react/no-array-index-key */
              index
            }
            style={{
              width: `calc(${100 / items?.length}% - ${
                ((items?.length - 1) * 20) / items?.length
              }px)`,
              minWidth,
            }}
          >
            {item}
          </SwiperSlideComponent>
        );
      })}
    </SwiperComponent>
  );
}
